import Img from '@/components/Img';
import styles from './ImageCards.module.scss';
import Text from '@/components/Text/Text';
import { Link } from '@/i18n/navigation';

type ImageCardsSectionProps = {
  data: {
    title: string;
    description: string;
    cards: {
      id: number;
      text: string;
      image: {
        id: number;
        alternativeText: string | null;
        width: number;
        height: number;
        url: string;
      };
      link: string;
    }[];
  };
};

const ImageCardsSection = ({ data }: ImageCardsSectionProps) => (
  <section className={styles.imageCardsSection}>
    <div className={styles.content}>
      <div className={styles.textContainer}>
        <Text tag='h2'>{data.title}</Text>
        <Text
          className={styles.description}
          tag='p'
        >
          {data.description}
        </Text>
      </div>
      {data.cards && (
        <div className={styles.itemsContainer}>
          {data.cards.map((post) => (
            <Link
              key={post.text}
              href={post.link}
              className={styles.item}
            >
              <div className={styles.imageWrapper}>
                <Img
                  className={styles.image}
                  src={post.image.url}
                  alt={post.image.alternativeText || post.text}
                />
                <div className={styles.overlay} />
              </div>
              <Text
                tag='p'
                className={styles.title}
                isFormattedText
              >
                {post.text}
              </Text>
            </Link>
          ))}
        </div>
      )}
    </div>
  </section>
);

export default ImageCardsSection;
